import { Widget, WidgetProps } from "@rjsf/core";

import { FormMessage, Checkbox } from "@xometry/xometry_loft";

import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, InlineLabelInput } from "./Shared.style";

export const LoftCheckboxField: Widget = ({
  disabled,
  onChange,
  options,
  rawErrors,
  required,
  schema,
  value,
}: WidgetProps) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  return (
    <div css={Section}>
      <div css={InlineLabelInput}>
        <Checkbox
          defaultChecked={value}
          disabled={disabled}
          name={options?.name as string}
          id={options?.name as string}
          enterKeyHint="Select"
          onChange={event => {
            event.stopPropagation();
            const isChecked = !!event.currentTarget?.checked;
            onChange(isChecked);
          }}
        />
        <LabelWithOptionalFlag
          required={required}
          htmlFor={options?.name as string}
          suffix=""
          tooltip={(options?.tooltip || "") as string}
        >
          {schema.title}
        </LabelWithOptionalFlag>
      </div>
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
